export default __webpack_public_path__ + "static/media/star.f7e7bd91.svg";